/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.MerchantAccountsOnboardingTesting {
    'use strict';

    class MerchantAccountsOnboardingTestingController extends Meevo.Components.CommonClasses.CommonControllerBase {

        static $inject = [
            'meevo.AppSettings',
            'meevo.components.common.BusinessInfoDataService',
            'meevo.components.modal.ModalService',
            'meevo.components.common.IdentityService',
            'meevo.components.logging.LoggingService',
            'meevo.components.common.SecurityService',
            'meevo.components.tracking.TrackingService',
            'meevo.components.busy.BusyService',
            '$rootScope',
            '$state',
            '$scope',
            'meevo.ContextParams',
            'meevo.components.short-cuts.ShortCutsService',
            '$translate',
            '$mdDialog',
            '$q'
        ];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.CommonClasses.ICommonDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $rootScope: angular.IRootScopeService,
            protected $state: any,
            protected $scope: angular.IScope,
            protected contextParams: any,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            protected $translate: angular.translate.ITranslateService,
            protected $mdDialog: ng.material.IDialogService,
            protected $q: angular.IQService) {

            super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);

            this.createContext();
        }

        createContext(): void {
            let vm = this;
            vm.busyService.start();
            vm.securityService.checkSection(vm.meevoSecurityKeys.REGISTER_MERCHANTACCOUNT).then(() => {
                vm.busyService.stop();
                vm.context = new MerchantAccountsOnboardingTestingContext(this.appSettings, this.dataService, this.modalService, this.identityService, this.loggingService, this.securityService, this.trackingService, this.busyService, this.$scope, this.$translate, this.$mdDialog, this.$q, this.$rootScope);
                super.createContext();
            });
        }

    }

    angular.module("meevo.plugins.merchantAccountsOnboardingTesting")
        .controller("meevo.plugins.merchantAccountsOnboardingTesting.MerchantAccountsOnboardingTestingController", MerchantAccountsOnboardingTestingController);
}
